import { reportTypes, generalTypes } from '../actions'

const initialState = {
  players: {
    generating: false,
    url: ''
  }
}

const reports = (state = initialState, action) => {
  switch (action.type) {
    case generalTypes.ADMIN_INIT:
      return initialState
    case reportTypes.PLAYERS:
      let players = { ...state.players }
      players.generating = true
      return {
        ...state,
        players
      }
    case reportTypes.PLAYERS_RES:
      players = { ...state.players }
      players.generating = false
      return {
        ...state,
        players
      }
    case reportTypes.SAVE_URL:
      let { url, key } = action.payload
      let newState = { ...state }
      let update = { ...newState[key] }
      update.url = url
      newState[key] = update
      return newState
    default: return state
  }
}

export default reports



// WEBPACK FOOTER //
// ./src/reducers/reports.js